const subheadingsData = {
  1: [
    {
      title: "About Me",
      content: (
        <>
          <p>A senior FRONT-END developer, graduated from faculty of Computers and Artificial Intellignece.</p>
        </>
      ),
    },
  ],
  2: [
    {
      title: "2025 bachelor's degree",
      content: (
        <>
          <p>Bachelor's degree in Computer Science</p>
        </>
      ),
    },
    {
      title: "2024 ITI",
      content: (
        <>
          <p>ITI scholarship in WEB development</p>
        </>
      ),
    },
  ],
  3: [
    {
      title: "2025 frontend intern",
      content: (
        <>
          <p>Working in real-world projects within teams</p>
        </>
      )
    },
    {
      title: "2024 coding coashing",
      content: (
        <>
          <p>Online sessions for computer science students.</p>
        </>
      ),
    },
    {
      title: "2023 AI trainer",
      content: (
        <>
          <p>AI coding trainer at Outlier</p>
        </>
      ),
    },
    {
      title: "2023 web developer",
      content: (
        <>
          <p>Web developer at Freelance till now</p>
        </>
      ),
    },
  ],
};

export default subheadingsData;
